import { IHttpApi } from '@cian/http-api/shared/http';

import {
  fetchDeleteOfferFromFavorites,
  IDeleteOfferFromFavoritesRequest,
} from '../../../repositories/favorites/v1/delete-offer-from-favorites';
import { assertUnknownError } from './assert';
import { mapDeleteFavoriteResponse, mapDeleteFavoriteResponseError } from './mappers';
import { IDeleteOfferFromFavorites } from '../../../types/favorite';
import {
  EDealType,
  EEntityType,
} from '../../../repositories/favorites/entities/schemas/DeleteOfferFromFavoritesRequestSchema';

export async function deleteFavoriteRequest({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: Omit<IDeleteOfferFromFavoritesRequest, 'dealType' | 'entityType'>;
}): Promise<IDeleteOfferFromFavorites> {
  const response = await fetchDeleteOfferFromFavorites({
    httpApi,
    parameters: {
      dealType: EDealType.Sale,
      entityType: EEntityType.OfferResidental,
      ...parameters,
    },
    mappers: {
      200: mapDeleteFavoriteResponse,
      400: mapDeleteFavoriteResponseError,
    },
  });

  assertUnknownError(response);

  return response.response as IDeleteOfferFromFavorites;
}
